import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  width: 100px;
  margin: 120px auto 0;
`;
